import { jsx as C } from "react/jsx-runtime";
const V = ({ size: r }) => {
  switch (r) {
    case "sm":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M8 10.5479L5.15383 7.70172L5.8565 6.97872L7.5 8.62222V3.02222H8.5V8.62222L10.1435 6.97872L10.8462 7.70172L8 10.5479ZM4.20517 13.0222C3.86839 13.0222 3.58333 12.9056 3.35 12.6722C3.11667 12.4389 3 12.1538 3 11.8171V10.0094H4V11.8171C4 11.8684 4.02139 11.9154 4.06417 11.9581C4.10683 12.0008 4.15383 12.0222 4.20517 12.0222H11.7948C11.8462 12.0222 11.8932 12.0008 11.9358 11.9581C11.9786 11.9154 12 11.8684 12 11.8171V10.0094H13V11.8171C13 12.1538 12.8833 12.4389 12.65 12.6722C12.4167 12.9056 12.1316 13.0222 11.7948 13.0222H4.20517Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M12 15.8107L7.73075 11.5415L8.78475 10.457L11.25 12.9222V4.52222H12.75V12.9222L15.2153 10.457L16.2693 11.5415L12 15.8107ZM6.30775 19.5222C5.80258 19.5222 5.375 19.3472 5.025 18.9972C4.675 18.6472 4.5 18.2196 4.5 17.7145V15.003H6V17.7145C6 17.7915 6.03208 17.862 6.09625 17.926C6.16025 17.9901 6.23075 18.0222 6.30775 18.0222H17.6923C17.7692 18.0222 17.8398 17.9901 17.9038 17.926C17.9679 17.862 18 17.7915 18 17.7145V15.003H19.5V17.7145C19.5 18.2196 19.325 18.6472 18.975 18.9972C18.625 19.3472 18.1974 19.5222 17.6923 19.5222H6.30775Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M10 13.1793L6.44229 9.62159L7.32063 8.71784L9.375 10.7722V3.77222H10.625V10.7722L12.6794 8.71784L13.5577 9.62159L10 13.1793ZM5.25646 16.2722C4.83549 16.2722 4.47917 16.1264 4.1875 15.8347C3.89583 15.5431 3.75 15.1867 3.75 14.7658V12.5062H5V14.7658C5 14.8299 5.02674 14.8887 5.08021 14.942C5.13354 14.9955 5.19229 15.0222 5.25646 15.0222H14.7435C14.8077 15.0222 14.8665 14.9955 14.9198 14.942C14.9733 14.8887 15 14.8299 15 14.7658V12.5062H16.25V14.7658C16.25 15.1867 16.1042 15.5431 15.8125 15.8347C15.5208 16.1264 15.1645 16.2722 14.7435 16.2722H5.25646Z",
          fill: "currentColor"
        }
      );
  }
}, t = ({ size: r }) => {
  switch (r) {
    case "sm":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M7.99883 10.6411L4.47417 7.11641L5.539 6.02624L7.2405 7.73157V2.55341H8.75717V7.73157L10.4587 6.02624L11.5235 7.11641L7.99883 10.6411ZM4.04667 13.4911C3.62689 13.4911 3.26917 13.3432 2.9735 13.0476C2.67783 12.7519 2.53 12.3942 2.53 11.9744V9.97441H4.04667V11.9744H11.951V9.97441H13.4677V11.9744C13.4677 12.3942 13.3198 12.7519 13.0242 13.0476C12.7285 13.3432 12.3708 13.4911 11.951 13.4911H4.04667Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M11.998 15.9505L6.711 10.6635L8.30825 9.02822L10.8605 11.5862V3.81897H13.1355V11.5862L15.6878 9.02822L17.285 10.6635L11.998 15.9505ZM6.06975 20.2255C5.44009 20.2255 4.9035 20.0037 4.46 19.5602C4.0165 19.1167 3.79475 18.5801 3.79475 17.9505V14.9505H6.06975V17.9505H17.9263V14.9505H20.2013V17.9505C20.2013 18.5801 19.9795 19.1167 19.536 19.5602C19.0925 20.0037 18.5559 20.2255 17.9263 20.2255H6.06975Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M9.9987 13.2957L5.59287 8.88991L6.92391 7.5272L9.05078 9.65887V3.18616H10.9466V9.65887L13.0735 7.5272L14.4045 8.88991L9.9987 13.2957ZM5.05849 16.8582C4.53377 16.8582 4.08662 16.6734 3.71703 16.3039C3.34745 15.9343 3.16266 15.4871 3.16266 14.9624V12.4624H5.05849V14.9624H14.9389V12.4624H16.8347V14.9624C16.8347 15.4871 16.65 15.9343 16.2804 16.3039C15.9108 16.6734 15.4636 16.8582 14.9389 16.8582H5.05849Z",
          fill: "currentColor"
        }
      );
  }
}, e = ({
  size: r = "md",
  weight: L = "default"
}) => {
  switch (L) {
    case "bold":
      return /* @__PURE__ */ C(t, { size: r });
    case "book":
    case "default":
      return /* @__PURE__ */ C(V, { size: r });
  }
};
export {
  e as default
};
//# sourceMappingURL=DIconDownload.js.map
